/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Modality_Team_SportInputs */

const en_us2_modality_team_sport = /** @type {(inputs: Modality_Team_SportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team sport`)
};

const pt_br2_modality_team_sport = /** @type {(inputs: Modality_Team_SportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esporte coletivo`)
};

const es_419_modality_team_sport = /** @type {(inputs: Modality_Team_SportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deporte de equipo`)
};

const pt_pt2_modality_team_sport = /** @type {(inputs: Modality_Team_SportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desporto coletivo`)
};

const fr_fr2_modality_team_sport = /** @type {(inputs: Modality_Team_SportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sport collectif`)
};

const de_de2_modality_team_sport = /** @type {(inputs: Modality_Team_SportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mannschaftssport`)
};

const it_it2_modality_team_sport = /** @type {(inputs: Modality_Team_SportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sport di squadra`)
};

/**
* | output |
* | --- |
* | "Team sport" |
*
* @param {Modality_Team_SportInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const modality_team_sport = /** @type {((inputs?: Modality_Team_SportInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Modality_Team_SportInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_modality_team_sport(inputs)
	if (locale === "es-419") return es_419_modality_team_sport(inputs)
	if (locale === "pt-PT") return pt_pt2_modality_team_sport(inputs)
	if (locale === "fr-FR") return fr_fr2_modality_team_sport(inputs)
	if (locale === "de-DE") return de_de2_modality_team_sport(inputs)
	if (locale === "it-IT") return it_it2_modality_team_sport(inputs)
	return en_us2_modality_team_sport(inputs)
});
export { modality_team_sport as "modality.team_sport" }